import { Component } from 'react';
import PropTypes from 'prop-types';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import MarkerList from './MarkerList';

class ActorMapContainer extends Component {
	constructor(props) {
		super(props);
		this.mapRef = null;
		this.onCreated = this.onCreated.bind(this);
	}

	componentWillUnmount() {
		const map = this.mapRef;
		if (map) {
			map.off();
		}
	}

	onCreated(mapInstance) {
		this.mapRef = mapInstance;
		mapInstance.on('moveend', () => this.props.onMoveEnd && this.props.onMoveEnd(mapInstance));

		if (this.props.keepCenterOnZoom) {
			mapInstance.on('zoomend', () => {
				mapInstance.setView(this.props.center);
			});
		}

		this.props.onCreated && this.props.onCreated(mapInstance);
	}

	render() {
		let maxZoom = this.props.maxZoom;
		if (!maxZoom || maxZoom > 11) {
			maxZoom = 11;
		}

		return (
			<MapContainer {...this.props} maxZoom={maxZoom} zoomControl={false} whenCreated={this.onCreated}>
				<TileLayer url="https://maps.maptilehoster.com/vxone/{z}/{x}/{y}.png" />
				{this.props.markers && (
					<MarkerList
						avoidDuplicates={this.props.avoidDuplicates}
						markers={this.props.markers}
						zoom={this.mapRef ? this.mapRef.getZoom() : this.props.zoom}
					/>
				)}
				{this.props.zoomControl && <ZoomControl position="bottomright" />}
			</MapContainer>
		);
	}
}

ActorMapContainer.propTypes = {
	markers: PropTypes.array,
	center: PropTypes.array,
	avoidDuplicates: PropTypes.bool,
	keepCenterOnZoom: PropTypes.bool,
	zoomControl: PropTypes.bool,
	zoom: PropTypes.number,
	maxZoom: PropTypes.number,
	onCreated: PropTypes.func,
	onMoveEnd: PropTypes.func,
	onSetMapRef: PropTypes.func,
};

ActorMapContainer.defaultProps = {
	markers: [],
	center: [],
	avoidDuplicates: true,
	keepCenterOnZoom: false,
	zoomControl: false,
	zoom: 13,
	maxZoom: 11,
};

export default ActorMapContainer;
